import React from "react";
import { Select } from "components/select/index";

export interface IWebsiteBuilderPopupOption<T> {
  label: string;
  value: T;
}

export function renderWebsiteBuilderPopupOptions<T extends string | number>(options: IWebsiteBuilderPopupOption<T>[]) {
  const { Option } = Select;

  return (
    <>
      {options?.map((option, index) => (
        <Option key={index} value={option.value}>
          <span>{option.label}</span>
        </Option>
      ))}
    </>
  );
}
